export default {
  getEntities: (state) => state.ids
    .slice(0, (state.meta.page * state.meta.itemsPerPage))
    .map((id) => state.entities[id]),
};
